import { inject } from '@angular/core';
import { Router, CanActivateFn, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * Root redirect guard - redirects to appropriate dashboard based on user_type
 * Used for the root route '/' to send users to their correct dashboard
 */
export const rootRedirectGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.authReady$.pipe(
        take(1),
        map((authenticated) => {
            if (!authenticated) {
                return router.createUrlTree(['/auth']);
            }

            const userType = authService.currentUserType();
            return redirectByUserType(userType, authService, router);
        })
    );
};

function redirectByUserType(
    userType: string | null,
    authService: AuthService,
    router: Router
): boolean | UrlTree {
    switch (userType) {
        case 'owner':
            return router.createUrlTree(['/dashboard']);
        case 'agency':
            return router.createUrlTree(['/agency/dashboard']);
        case 'maid':
            return router.createUrlTree(['/maid/dashboard']);
        case 'employer':
            return router.createUrlTree(['/employer']);
        default:
            // Fallback - shouldn't happen
            authService.logout();
            return router.createUrlTree(['/auth']);
    }
}
